import { Controller } from "@hotwired/stimulus"

// El formulario del recurso habla distinto según el formato elegido: una
// "Clase" pide objetivos y pauta; cualquier otro material, descripción y
// guía de uso. Reacciona en vivo a los chips de Formato: cambia título y
// bajada de los pasos indicados (textosValue: { paso: { clase, resto } }),
// alterna los elementos solo-de-clase y avisa al índice de avance.
export default class extends Controller {
  static targets = ["soloClase"]
  static values = { textos: Object }

  aplicar(event) {
    if (event.target.name !== "resource[category]") return

    const variante = this.formato() === "clase" || this.formato() === "" ? "clase" : "resto"

    Object.entries(this.textosValue).forEach(([paso, variantes]) => {
      const seccion = document.getElementById(`paso-${paso}`)
      if (!seccion) return

      const [titulo, bajada] = variantes[variante]
      const encabezado = seccion.querySelector("h2")
      if (encabezado) encabezado.textContent = titulo
      const subtitulo = seccion.querySelector("h2 + p")
      if (subtitulo) subtitulo.textContent = bajada
      seccion.dataset.titulo = titulo
    })

    this.soloClaseTargets.forEach((el) => el.classList.toggle("hidden", variante !== "clase"))
    // El índice de avance lee los títulos al armarse: que se rearme.
    this.dispatch("titulos", { prefix: "formulario" })
  }

  formato() {
    return this.element.querySelector("input[name='resource[category]']:checked")?.value || ""
  }
}
